var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLightning = function SvgIconLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.457.61a1 1 0 0 1 .524 1.086l-1.334 6.666 5.204 1.952a1 1 0 0 1 .38 1.618l-10.5 11.25a1 1 0 0 1-1.712-.878l1.334-6.666-5.204-1.952a1 1 0 0 1-.38-1.618l10.5-11.25A1 1 0 0 1 15.457.61M6.252 12.34l4.6 1.725a1 1 0 0 1 .629 1.132l-.81 4.048 7.077-7.583-4.6-1.725a1 1 0 0 1-.629-1.132l.81-4.048z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLightning;